<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;

    /**
     * Component is only for syntactic convenience, so we won't need to duplicate many lines of html in DraggableListItem.svelte
     */
    import DropArea from './DropArea.svelte';

    export let dropArea;
    export let key;
    export let draggableGroupKey;
    export let disabled;
</script>

{#if dropArea}
    <DropArea {disabled} focusable={false} {draggableGroupKey} {key} on:update on:dragOver on:dragOut>
        <slot />
    </DropArea>
{:else}
    <div>
        <slot />
    </div>
{/if}
